import { AppRoutes } from '../../App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const auditTrailRoot = 'auditTrail';
export const auditTrailBaseRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${auditTrailRoot}`;
